
import { Link } from "react-router-dom";

/**
 * Pick Pack Pro - "How It Works" section
 * Single-file React component (styles included).
 */

/* ---------------- Icons ---------------- */
const Check = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">
    <circle cx="10" cy="10" r="10" fill="#0a5cf5" />
    <path d="M5.8 10.4l2.9 2.9 5.5-5.8" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Arrow = ({ size = 22, stroke = "#0a5cf5", sw = 2.2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14" />
    <path d="M13 6l6 6-6 6" />
  </svg>
);

const IconLink = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
    <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
  </svg>
);
const IconWarehouse = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 10l9-6 9 6v10H3z" />
    <path d="M8 20v-6h8v6" />
    <path d="M8 16.5h8" />
  </svg>
);
const IconBox = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" />
    <path d="M4 7.5l8 4.5 8-4.5" />
    <path d="M12 12v9" />
  </svg>
);
const IconChart = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20V10" />
    <path d="M10 20V4" />
    <path d="M16 20v-8" />
    <path d="M22 20H2" />
  </svg>
);

const TrustCheck = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1b2b4b" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.5 12.5A8.5 8.5 0 1 1 15 4.2" />
    <path d="M8 11.5l3.2 3.2L20 6" />
  </svg>
);
const TrustGear = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1b2b4b" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3.2" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.9.3h0a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9v0a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
  </svg>
);
const TrustTruck = () => (
  <svg width="28" height="26" viewBox="0 0 28 24" fill="none" stroke="#1b2b4b" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 5h14v12H2z" />
    <path d="M16 9h5l4 4v4h-9z" />
    <circle cx="7" cy="18.5" r="2.2" fill="#fff" />
    <circle cx="20" cy="18.5" r="2.2" fill="#fff" />
    <path d="M5 9h6" />
  </svg>
);

/* ---------------- Data ---------------- */
const STEPS = [
  {
    n: "01",
    color: "orange",
    title: "Connect Your Store",
    text: "Connect Amazon, Shopify, TikTok Shop, and eBay in minutes.",
    icon: <IconLink />,
    list: ["Connect store", "Import products", "Sync inventory"],
    img: "/homepageimages/process-step-1.png"
  },
  {
    n: "02",
    color: "blue",
    title: "Automate Operations",
    text: "We receive your inventory and fulfilment with intelligent workflows.",
    icon: <IconWarehouse />,
    list: ["Receive inventory", "Barcode & check", "Sync stock"],
    img: "/homepageimages/process-step-2.jpg"
  },
  {
    n: "03",
    color: "orange",
    title: "Fulfil with Precision",
    text: "Fast, accurate order fulfilment with real-time inventory visibility and control.",
    icon: <IconBox />,
    list: ["Pick", "Pack", "Quality check", "Ship"],
    img: "/homepageimages/process-step-3.jpg"
  },
  {
    n: "04",
    color: "blue",
    title: "Scale with Confidence",
    text: "Live dashboards and performance insights that reduce costs and accelerate growth.",
    icon: <IconChart />,
    list: ["Track orders", "Live reporting", "Scale globally"],
    img: "/homepageimages/process-step-4.png"
  },
];

const TRUST = [
  { icon: <TrustCheck />, label: "No long-term contracts" },
  { icon: <TrustGear />, label: "Dedicated UK support" },
  { icon: <TrustTruck />, label: "Fast onboarding" },
];

/* ---------------- Styles ---------------- */
const css = `


.hiw {
    --navy: #0b1533;
    --blue: #0a5cf5;
    --orange: #F68C43;
    --gap: 22px;
    position: relative;
    width: 100%;
    padding: 40px 0;
    box-sizing: border-box;
    font-family: var(--font-body, 'Open Sans', system-ui, -apple-system, sans-serif);
  }
  
  .hiw__wrap { box-sizing: border-box; padding: 0 20px;
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
  }
  
  .hiw__head {
    text-align: left;
  }
  
  .hiw__eyebrow {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 1.5px;
    color: #64748B;
    text-transform: uppercase;
    margin-bottom: 20px;
  }
  .hiw__eyebrow i {
    display: inline-block;
    width: 24px;
    height: 2px;
    background: #F68C43;
    flex-shrink: 0;
  }
  .hiw__title {
    margin: 8px 0;
    font-size: 2.5rem;
    line-height: 1.1; font-weight: 800; letter-spacing: -.025em; color: var(--navy);
    text-transform: none;
  }
  .hiw__title span { color: var(--orange); }
  .hiw__sub {
    max-width: 800px; margin: 0;
    font-size: clamp(14px, 1.5vw, 16px); line-height: 1.7; color: #3b4766; font-weight: 400;
    text-transform: none;
    letter-spacing: normal;
  }

/* Connector row */
.hiw__track { position: relative; margin-top: clamp(20px, 3vw, 28px); }
.hiw__connector {
  position: absolute; left: 2.2%; right: 2.2%; top: 24px; height: 60px;
  border: 2px dashed #c9d3ea; border-bottom: none;
  border-radius: 44px 44px 0 0;
  z-index: 0;
}
.hiw__top {
  position: relative; z-index: 2;
  display: grid; grid-template-columns: repeat(4, 1fr); column-gap: var(--gap);
  height: 48px;
}
.hiw__num {
  justify-self: center;
  width: 38px; height: 38px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 16px; font-weight: 800; color: #ffffff !important;
  border: 3px solid #fff;
}
.hiw__num--orange { background: var(--orange); box-shadow: 0 0 0 4px rgba(255,106,19,.14), 0 10px 22px rgba(255,106,19,.35); }
.hiw__num--blue   { background: var(--blue);   box-shadow: 0 0 0 4px rgba(10,92,245,.14), 0 10px 22px rgba(10,92,245,.32); }

.hiw__arrow {
  position: absolute; top: 6px; z-index: 3;
  width: 36px; height: 36px; margin-left: -18px;
  border-radius: 50%; background: #fff;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 8px 22px rgba(30,60,130,.14);
}
.hiw__arrow--1 { left: calc((100% - 3 * var(--gap)) / 4 + var(--gap) / 2); }
.hiw__arrow--2 { left: calc((100% - 3 * var(--gap)) / 2 + var(--gap) * 1.5); }
.hiw__arrow--3 { left: calc((100% - 3 * var(--gap)) * .75 + var(--gap) * 2.5); }

/* Cards */
.hiw__cards {
  position: relative; z-index: 1;
  display: grid; grid-template-columns: repeat(4, 1fr); gap: var(--gap);
  margin-top: 14px;
}
.hiw__card {
  position: relative;
  background: rgba(255,255,255,.96);
  border-radius: 24px;
  padding: 8px 8px 16px;
  box-shadow: 0 18px 44px rgba(40,70,140,.10), 0 2px 6px rgba(40,70,140,.04);
  min-height: 260px;
  overflow: hidden;
}
.hiw__media {
  position: relative; height: 110px; border-radius: 16px; overflow: visible;
}
.hiw__img {
  position: absolute; inset: 0; width: 100%; height: 100%;
  object-fit: cover; border-radius: 14px;
  -webkit-mask-image: linear-gradient(180deg, #000 70%, transparent 100%);
          mask-image: linear-gradient(180deg, #000 70%, transparent 100%);
}
.hiw__panel {
  position: absolute; right: 6px; top: 8px;
  min-width: 100px; padding: 4px 6px;
  background: rgba(255,255,255,.97);
  border-radius: 10px;
  box-shadow: 0 10px 26px rgba(30,50,110,.16);
  z-index: 2;
}
.hiw__row {
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
  padding: 3px 0; font-size: 9.5px; font-weight: 600; color: #1d2a4a; white-space: nowrap;
}
.hiw__row + .hiw__row { border-top: 1px solid #eef1f8; }
.hiw__badge {
  position: absolute; left: 10px; bottom: -19px; z-index: 3;
  width: 48px; height: 48px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  background: linear-gradient(180deg, #1a6dff, #0a52e0);
  border: 3px solid #fff;
  box-shadow: 0 10px 22px rgba(10,92,245,.32);
}
.hiw__bignum {
  position: absolute; right: 14px; bottom: 50px;
  font-size: 48px; line-height: 1; font-weight: 800;
  color: rgba(10,92,245,.07); letter-spacing: -.02em;
  pointer-events: none; user-select: none;
}
.hiw__body { padding: 30px 10px 0; position: relative; z-index: 1; }
.hiw__ctitle { margin: 0 0 8px; font-size: clamp(15px, 2vw, 17px); font-weight: 800; color: var(--navy); letter-spacing: -.01em; }
.hiw__ctext { margin: 0; font-size: clamp(12px, 1.3vw, 14px); line-height: 1.4; color: #3d4968; }

/* CTA */
.hiw__cta { text-align: center; margin-top: 16px; }
.hiw__btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 16px;
  min-width: 240px; padding: 12px 30px;
  border: none; border-radius: 8px; cursor: pointer;
  font-family: inherit; font-size: 18px; font-weight: 700; color: #ffffff !important;
  background: linear-gradient(180deg, #1264ff 0%, #0a52e6 100%);
  box-shadow: 0 14px 28px rgba(10,92,245,.30);
  transition: transform .2s, box-shadow .2s;
  text-decoration: none;
}
.hiw__btn:hover { transform: translateY(-2px); box-shadow: 0 18px 34px rgba(10,92,245,.38); }
.hiw__btn svg { transition: transform .2s; }
.hiw__btn:hover svg { transform: translateX(4px); }

/* Trust row */
.hiw__trust {
  display: flex; align-items: center; justify-content: center; flex-wrap: wrap;
  margin-top: 20px;
}
.hiw__trust-item {
  display: flex; align-items: center; gap: 14px;
  padding: 0 clamp(10px, 2vw, 28px); font-size: clamp(12px, 1.3vw, 15px); font-weight: 500; color: #3a4666;
}
.hiw__trust-item + .hiw__trust-item { border-left: 1px solid #d5dcec; }

/* Responsive */
@media (max-width: 1180px) {
  .hiw__cards { grid-template-columns: repeat(2, 1fr); }
  .hiw__track .hiw__connector, .hiw__top { display: none; }
  .hiw__track { margin-top: 28px; }
}
@media (max-width: 768px) {
    .hiw { padding: 40px 0; }
  }
  @media (max-width: 680px) {
  .hiw__cards { grid-template-columns: 1fr; }
  .hiw__sub { font-size: 16px; }
  .hiw__trust-item { padding: 8px 18px; border-left: none !important; }
}
`;

/* ---------------- Component ---------------- */
export default function Process() {
  return (
    <section className="hiw">
      <style>{css}</style>

      <div className="hiw__wrap">
        {/* Header */}
        <div className="hiw__head">
          <div className="hiw__eyebrow">
            <i />
            <span>How It Works</span>
          </div>
          <h2 className="hiw__title">
            Streamlined Fulfilment, <span className="text-orange">Step by Step</span>
          </h2>
          <p className="hiw__sub">
            Connect your store, send your inventory, and start selling. Our Amazon FBA
            fulfilment and eCommerce fulfilment services in the UK simplify operations,
            improve accuracy, and support scalable growth.
          </p>
        </div>

        {/* Steps */}
        <div className="hiw__track">
          <div className="hiw__connector" />

          <div className="hiw__top">
            {STEPS.map((s) => (
              <div key={s.n} className={`hiw__num hiw__num--${s.color}`}>
                {s.n}
              </div>
            ))}
            <div className="hiw__arrow hiw__arrow--1"><Arrow /></div>
            <div className="hiw__arrow hiw__arrow--2"><Arrow /></div>
            <div className="hiw__arrow hiw__arrow--3"><Arrow /></div>
          </div>

          <div className="hiw__cards">
            {STEPS.map((s) => (
              <article key={s.n} className="hiw__card">
                <div className="hiw__media">
                  <img className="hiw__img" src={s.img} alt={s.title} />
                  <div className="hiw__panel">
                    {s.list.map((item) => (
                      <div className="hiw__row" key={item}>
                        <span>{item}</span>
                        <Check />
                      </div>
                    ))}
                  </div>
                  <div className="hiw__badge">{s.icon}</div>
                </div>

                <div className="hiw__bignum">{s.n}</div>

                <div className="hiw__body">
                  <h3 className="hiw__ctitle">{s.title}</h3>
                  <p className="hiw__ctext">{s.text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="hiw__cta">
          <Link to="/contact-fulfillment-services" className="hiw__btn">
            Get Started <Arrow size={22} stroke="#fff" sw={2.4} />
          </Link>
        </div>

        {/* Trust row */}
        <div className="hiw__trust">
          {TRUST.map((t) => (
            <div className="hiw__trust-item" key={t.label}>
              {t.icon}
              <span>{t.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}







